import React from "react";
import { Link2, Cpu, FileText, Handshake } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function HowItWorks() {
    const { t } = useTranslation();

    const steps = [
        {
            n: "01",
            title: t("landing.how.step1Title"),
            icon: Link2,
            body: t("landing.how.step1Body"),
        },
        {
            n: "02",
            title: t("landing.how.step2Title"),
            icon: Cpu,
            body: t("landing.how.step2Body"),
        },
        {
            n: "03",
            title: t("landing.how.step3Title"),
            icon: FileText,
            body: t("landing.how.step3Body"),
        },
        {
            n: "04",
            title: t("landing.how.step4Title"),
            icon: Handshake,
            body: t("landing.how.step4Body"),
        },
    ];

    return (
        <section
            id="how"
            className="scroll-mt-20 border-b-2 border-black bg-white"
            data-testid="how-section"
        >
            {/* Header */}
            <div className="border-b-2 border-black">
              <div className="mx-auto max-w-[1920px] p-8 md:p-12 lg:p-16">
                <div className="flex flex-col md:flex-row md:items-start md:gap-16">
                    <div className="mb-6 md:mb-0 shrink-0">
                        <span className="font-mono text-xs tracking-[0.25em] uppercase border-2 border-black bg-white px-3 py-1">
                            {t("landing.how.eyebrow")}
                        </span>
                    </div>
                    <div>
                        <h2 className="font-display text-4xl md:text-6xl uppercase leading-[0.95] tracking-tighter">
                            {t("landing.how.headlineLine1")}
                            <br />
                            {t("landing.how.headlineLine2")}
                            <br />
                            <span className="bg-black text-white px-2 -mx-0.5">
                                {t("landing.how.headlineHighlight")}
                            </span>
                        </h2>
                    </div>
                </div>
              </div>
            </div>

            {/* Steps grid - detached cards */}
            <div className="bg-zinc-50 py-12 px-6 md:px-12">
                <div className="mx-auto max-w-[1920px] grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                    {steps.map((s, i) => {
                        const Icon = s.icon;
                        return (
                            <div
                                key={s.n}
                                data-testid={`how-step-${i + 1}`}
                                className="bg-white p-6 md:p-8 border-2 border-black shadow-brutal"
                            >
                                <span className="font-display text-5xl md:text-6xl tracking-tight block mb-3">
                                    {s.n}
                                </span>
                                <Icon
                                    size={40}
                                    strokeWidth={1.5}
                                    className="mb-4"
                                    aria-hidden="true"
                                />
                                <h3 className="font-display text-xl uppercase tracking-tight mb-2">
                                    {s.title}
                                </h3>
                                <p className="text-sm leading-relaxed text-zinc-700">
                                    {s.body}
                                </p>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
